import React from 'react'

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

import profilePic from './profile-pic.jpg'
import { rhythm } from '../utils/typography'

class Bio extends React.Component {
  render() {
    return (
      <div
        style={{
          marginBottom: rhythm(2.5),
        }}
      >
        <p>
          A digital scrapbook by William Park. It contains details about my final project "Habeats" for my final project at Interaction Design Belfast.
        </p>
        <p>
          <strong>This material is my submission for IXD501.</strong>
        </p>
      </div>
    )
  }
}

export default Bio
